import { useMutation } from "@apollo/client/react";
import {
  GenerateOpenCalcMutation,
  GenerateOpenCalcMutationVariables,
  GenerateOpenCalcDocument,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook for starting the ai import.
 * @returns {Object} - Contains the startAIImport function, loading state, and error state.
 */
export default function useGenerateOpenCalcHook(): {
  generateOpenCalc: any;
  loading: any;
  error: any;
  } {
  const [generateOpenCalc, { loading, error }] = useMutation<GenerateOpenCalcMutation, GenerateOpenCalcMutationVariables>(GenerateOpenCalcDocument);

  return {
    generateOpenCalc,
    loading,
    error,
  };
}
